import { FC } from 'react';

type Props = {
	className?: string;
};

const StatusInactiveIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#EAEAEA'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2.33301 10.0001C2.33301 14.4184 5.91477 18.0002 10.3331 18.0002C14.7514 18.0002 18.3332 14.4184 18.3332 10.0001C18.3332 5.58176 14.7514 2 10.3331 2C5.91477 2 2.33301 5.58176 2.33301 10.0001ZM7.57431 7.24125C7.86496 6.95064 8.33615 6.95067 8.62676 7.2413L10.3331 8.94779L12.0395 7.2413C12.3301 6.95067 12.8012 6.95064 13.0919 7.24125C13.3825 7.53186 13.3825 8.00305 13.0919 8.2937L11.3855 10.0003L13.0914 11.7064C13.3821 11.9971 13.3821 12.4683 13.0914 12.7589C12.8008 13.0495 12.3295 13.0495 12.0389 12.7589L10.3331 11.0528L8.62724 12.7589C8.33663 13.0495 7.86543 13.0495 7.57479 12.7589C7.28415 12.4683 7.28412 11.9971 7.57474 11.7064L9.28073 10.0003L7.57426 8.2937C7.28364 8.00305 7.28367 7.53186 7.57431 7.24125Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default StatusInactiveIcon;
